// import { VehicleManufacturer } from "./manufacturers/types";
// import { VehicleModel } from "./models/types";
// import { VehicleType } from "./types/types";

import { VehicleManufacturer } from "services/api/catalog/vehicles/manufacturers/types";
import { VehicleModel } from "services/api/catalog/vehicles/models/types";
import { VehicleType } from "services/api/catalog/vehicles/types/types";
import { Contact } from "services/api/contacts/types";
import { AdvancedSearchFormValues } from "services/search";
import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import { FleetDocumentUpload } from "./documents/types";
import { OwnerType } from "./owners/types";
import { VehicleLocation, VehicleLocationFormValues } from "./locations/types";
import { FleetVehicleServiceEditFormValues } from "./services/types";


export interface VehiclePrice {
  netPrice: number | null;
  specialTax: number | null;
  ecoFee: number | null;
  vehicleInVatSystem: boolean;
  sellingPrice: number | null;
  discountType: 'percentage' | 'amount' | null;
  discountValue: number | null;
  netDiscount: number | null;
  totalPurchasePrice: number | null;
  margin: number | null;
  marginPercentage: number | null;
  totalExpenses: number | null;
  netMargin: number | null;
  netMarginPercentage: number | null;
}

export interface FleetVehicle {
  id: string;
  defaultImage?: string;
  vehicleColorId: string | null;
  colorName: string | null;
  created: Date;
  cylinderCapacity: string;
  firstRegistrationDate: Date | null;
  fuelType: string;
  hp: number;
  kmTraveled: number;
  kw: number;
  name: string;
  registrationExpiration: Date;
  registrationPlate: string;
  secondaryFuelType: string;
  price: VehiclePrice;
  vehicleCategory: { id: string; name: string } | null;
  vehicleManufacturer: VehicleManufacturer;
  vehicleModel: VehicleModel;
  vehicleType: VehicleType;
  vinNumber: string;
  ownerType: OwnerType;
  ownerContact: Contact;
  purchaseDate: Date;
  leaseActivationDate: Date;
  warrantyExpirationDate: Date;
  warrantyMileageLimit: number;
  autoInsuranceExpiryDate: Date | null;
  autoInsuranceContactId: string;
  autoInsuranceContact: Contact | null;
  cascoExpiryDate: Date | null;
  cascoContact: Contact | null;
  status: string | null;
  /** Trenutna lokacija vozila. Prazno za vozila koja je nikad nisu dobila. */
  location: VehicleLocation | null;
  pictures: FleetDocumentUpload[];
}





/*---------------------------------------------------------------
    SEARCH
  ---------------------------------------------------------------*/
export interface FleetVehicleRow {
  id: string;
  name: string | null;
  picture: string | null;
  vehicleManufacturer: VehicleManufacturer | null;
  vehicleModel: VehicleModel | null;
  vehicleType: VehicleType | null;
  vinNumber: string | null;
  firstRegistrationDate: Date | null;
  registrationPlate: string | null;
  registrationExpiration: Date | null;
  vehicleColorId: string | null;
  colorName: string | null;
  kmTraveled: number | null;
  status: string | null;
  location: VehicleLocation | null;
  price: VehiclePrice;
}

export interface FleetVehicleSearchFormValues {
  search: string | null;
  vehicleCategoryId: string | null;
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
  vehicleTypeId: string | null;
  vinNumber: string | null;
  firstRegistrationDateFrom: Date | null;
  firstRegistrationDateTo: Date | null;
  registrationPlate: string | null;
  registrationExpirationFrom: Date | null;
  registrationExpirationTo: Date | null;
  kwFrom: number | null;
  kwTo: number | null;
  kmTraveledFrom: number | null;
  kmTraveledTo: number | null;
  condition: string | null; // "new" | "used" | null — stanje vozila (Novo/Rabljeno)
  fuelType: string | null; // kod goriva (D/P/E/H/LPG/CNG) — prati VehicleType.FuelType na API-ju
  statuses: string[]; // statusi vozila koji ulaze u rezultate (prazno = svi)
  officeId: string | null; // poslovnica u kojoj se vozilo trenutno nalazi
  advancedSearch: AdvancedSearchFormValues[];
}

/*---------------------------------------------------------------
     EDIT
 ---------------------------------------------------------------*/
export interface FleetVehicleEditFormValues {
  id?: string | null;
  vehicleCategoryId: string | null;
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
  vehicleTypeId: string | null;
  vinNumber: string | null;
  firstRegistrationDate: Date | null;
  registrationPlate: string | null;
  registrationExpiration: Date | null;
  kmTraveled: number | null;
  vehicleColorId: string | null;
  colorName: string | null;
  netPrice: number | null;
  discountType: 'percentage' | 'amount' | null;
  discountValue: number | null;
  netDiscount: number | null;
  specialTax: number | null;
  ecoFee: number | null;
  vehicleInVatSystem: boolean;
  sellingPrice: number | null;
  ownerTypeId: string | null;
  ownerContactId: string | null;
  purchaseDate: Date | null;
  leaseActivationDate: Date | null;
  warrantyExpirationDate: Date | null;
  warrantyMileageLimit: number | null;
  autoInsuranceExpiryDate: Date | null;
  autoInsuranceContactId: string | null;
  cascoExpiryDate: Date | null;
  cascoContactId: string | null;
  status: string | null;
  /** Lokacija vozila — obavezna pri unosu, kasnije se mijenja premještajem. */
  location: VehicleLocationFormValues | null;
  pictures: FleetDocumentUpload[];
  tiresCount?: number;
}

/*---------------------------------------------------------------
    DETAILS
  ---------------------------------------------------------------*/

export interface FleetVehicleColor {
  id: string;
  name: string;
}

/*---------------------------------------------------------------
    DETAILS
  ---------------------------------------------------------------*/

export interface FleetVehicleDetailFormValues {
  id?: string | null;
  defaultImage?: string | null;
  vehicleColorId: string | null;
  colorName: string | null;
  created: Date | null;
  cylinderCapacity: string | null;
  firstRegistrationDate: Date | null;
  fuelType: string | null;
  hp: number | null;
  kmTraveled: number | null;
  kw: number | null;
  name: string | null;
  registrationExpiration: Date | null;
  registrationPlate: string | null;
  secondaryFuelType: string | null;
  price: VehiclePrice;
  vehicleManufacturer: VehicleManufacturer | null;
  vehicleModel: VehicleModel | null;
  vehicleType: VehicleType | null;
  vinNumber: string | null;
  warrantyExpirationDate: Date | null;
  warrantyMileageLimit: number | null;
  autoInsuranceExpiryDate: Date | null;
  autoInsuranceContact: Contact | null;
  cascoExpiryDate: Date | null;
  cascoContact: Contact | null;
  status: string | null;
  location: VehicleLocation | null;
  pictures: FleetDocumentUpload[];
}


export interface VehicleCategory {
  id: string;
  name: string;
}

/*---------------------------------------------------------------
    IMPORT
  ---------------------------------------------------------------*/


export interface FleetVehicleImportModalFormValues {
  files: FileExtended[]
}

export interface VehicleImportRowError {
  row: number;
  message: string;
}

export interface VehicleImportResult {
  successCount: number;
  errors: VehicleImportRowError[];
}

export interface JomImportRequestItem {
  jom: string;
  vinNumber: string | null;
  registrationPlate: string | null;
  kmTraveled: number | null;
}

/*---------------------------------------------------------------
    STATUS
  ---------------------------------------------------------------*/

export enum FleetVehicleStatusEnum {
  ARRIVING = "ARRIVING",                 // U_DOLASKU
  AVAILABLE = "AVAILABLE",               // DOSTUPNO
  RESERVED = "RESERVED",                 // REZERVIRANO
  ACTIVE = "ACTIVE",                     // AKTIVNO
  ACTIVE_RENTAL = "ACTIVE_RENTAL",       // AKTIVNO_NAJAM
  ACTIVE_INTERNAL = "ACTIVE_INTERNAL",   // AKTIVNO_INTERNO
  UNAVAILABLE = "UNAVAILABLE",           // NEDOSTUPNO
  UNAVAILABLE_SERVICE = "UNAVAILABLE_SERVICE",                   // SERVIS
  UNAVAILABLE_DAMAGE = "UNAVAILABLE_DAMAGE",                     // STETA
  UNAVAILABLE_DOCUMENTATION = "UNAVAILABLE_DOCUMENTATION",       // PAPIRI
  SOLD = "SOLD",                         // PRODANO
}

/** Polja koja se mogu tražiti uz promjenu statusa — koje od njih, određuje status. */
export type FleetVehicleStatusDetailField =
  | "contact"
  | "driver"
  | "damage"
  | "offerSale"
  | "validFrom"
  | "validUntil"
  | "note"
  | "kmTraveled"
  | "depositAmount"
  | "location";

/** Odakle predložiti lokaciju kad se modal otvori — vrijedi samo za polje "location". */
export type FleetVehicleStatusLocationDefault = "contact" | "userOffice";

export interface FleetVehicleStatusDetailFieldConfig {
  field: FleetVehicleStatusDetailField;
  label: string;
  required?: boolean;
  /** Grupa kontakata za ContactDropdown ("S" dobavljač, "B" kupac). */
  contactGroupIds?: string[];
  /** Vrsta lokacije koja se predlaže (samo za polje "location"). */
  locationType?: string;
  locationDefault?: FleetVehicleStatusLocationDefault;
}

export interface FleetVehicleStatusDetailFormValues {
  validFrom: Date | null;
  validUntil: Date | null;
  note: string | null;
  contactId: string | null;
  /** Vozač kojem je vozilo zaduženo — vozač tog vozila. */
  driverId: string | null;
  vehicleDamageId: string | null;
  offerSaleId: string | null;
  kmTraveled: number | null;
  depositAmount: number | null;
  /** Premještaj koji prati promjenu statusa. Prazno = lokacija ostaje nepromijenjena. */
  location: VehicleLocationFormValues | null;
  /**
   * Servisni nalog koji se otvara uz status "Nedostupno – Servis". Šalje se kao blok
   * `service` da nalog i status nastanu u istoj transakciji.
   */
  service: FleetVehicleServiceEditFormValues | null;
}

export interface FleetVehicleStatusHistoryRow {
  id: string;
  status: string;
  validFrom: Date | null;
  validUntil: Date | null;
  note: string | null;
  contactId: string | null;
  contactName: string | null;
  driverId: string | null;
  driverName: string | null;
  vehicleDamageId: string | null;
  vehicleDamageName: string | null;
  offerSaleId: string | null;
  offerSaleNumber: string | null;
  kmTraveled: number | null;
  depositAmount: number | null;
  created: Date;
  userCreatedName: string | null;
}

export interface FleetVehicleStatusConfig {
  label: string;
  color: string;
  dotColor: string;
  strokeColor: string;
  parentStatus: FleetVehicleStatusEnum | null;
  subStatuses?: FleetVehicleStatusEnum[];
}

